import { useState, useEffect, SetStateAction, Dispatch, useRef } from 'react';
import '../App.css';
import '../style.css';
import logo from '../image/logo.webp';
import logoDark from '../image/logo_dark.png';
import { Link, useLocation } from 'react-router-dom';
import { NavMenuItem } from './navMenuItem';
import React from 'react';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';
import { useResolvedTheme } from '../contexts/ThemeContext';

function Navigator(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
  const navRef = useRef<HTMLDivElement>(null);
  const lastScrollYRef = useRef<number>(window.scrollY);
  const location = useLocation();
  const resolvedTheme = useResolvedTheme();

  useEffect(() => {
    // /work, /App, /Web, /2024, /2023, /2021, /life 페이지에서만 스크롤 이벤트 적용
    if (location.pathname !== '/work' && location.pathname !== '/App' && location.pathname !== '/Web' && location.pathname !== '/2024' && location.pathname !== '/2023' && location.pathname !== '/2021' && location.pathname !== '/life') {
      // 다른 페이지에서는 nav를 고정 위치에 유지
      if (navRef.current) {
        navRef.current.style.transform = 'translateY(0)';
      }
      return;
    }

    const handleScroll = () => {
      if (!navRef.current) return;
      
      const filterElement = document.querySelector('.filter') as HTMLElement | null;
      const filterTop = filterElement ? filterElement.offsetTop : 0;
      const navHeight = navRef.current.offsetHeight;
      
      if (window.scrollY > lastScrollYRef.current && window.scrollY > 250) {
        // 스크롤 다운 시 nav 숨기기
        navRef.current.style.transform = 'translateY(-100%)';
      } else if (window.scrollY >= filterTop - navHeight) {
        // filter가 나타날 때 nav를 위로 밀어올리기
        navRef.current.style.transform = 'translateY(-100%)';
      } else {
        // 일반적인 경우 nav 표시
        navRef.current.style.transform = 'translateY(0)';
      }
      lastScrollYRef.current = window.scrollY;
    };

    window.addEventListener('scroll', handleScroll);
    
    // 클린업 함수
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);

  return (
    <div className='nav' ref={navRef}>
      <Link to="/" onClick={() => props.setActiveNav(3)}>
            <img className='logo' src={resolvedTheme === 'dark' ? logoDark : logo} alt='Lynkim logo' />
      </Link>
      <div className='menu'>
        <Link to="/work" onClick={() => props.setActiveNav(1)} style={{textDecoration: 'none'}}>
          <NavMenuItem isSelected={props.activeNav === 1 } name='Works' />
        </Link>  
        <Link to="/life" onClick={() => props.setActiveNav(2)} style={{textDecoration: 'none'}}>
          <NavMenuItem isSelected={props.activeNav === 2 } name='Life' />
        </Link>
        <Link to="/" onClick={() => props.setActiveNav(3)} style={{textDecoration: 'none'}}>
          <NavMenuItem isSelected={props.activeNav === 3 } name='About' />
        </Link> 
        <LanguageToggle />
        {/* <ThemeToggle /> */}
      </div>
      
    </div>
  );
}

export default Navigator;

